import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, withRouter } from 'react-router-dom';
import {
  Block,
  CenterMediumContent,
  ContainedButton,
  DefaultText,
  Form,
  FormActions,
  FullScreenSpinner,
  PasswordBox,
  TextBox,
} from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';
import { cognitoLogin, cognitoLogout, StateStatus, useCheckIsMobile } from '@guryou/redux';
import { authService, checkIfOwner } from '@guryou/utils';
import { useTheme } from '@material-ui/core/styles';
import { persistor } from 'store';
import './main.css';

const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
const Login = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const auth = useSelector(state => state.auth);
  const isMobile = useCheckIsMobile();
  const el = new URLSearchParams(window.location.search).get('el');
  const pw = new URLSearchParams(window.location.search).get('pw');

  useEffect(() => {
    dispatch(cognitoLogout());
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (el && pw) {
      dispatch(cognitoLogin({ email: decodeURIComponent(el), password: decodeURIComponent(pw), persistor }));
    }
  }, [dispatch, el, history, pw]);

  if (auth.status === StateStatus.LOADING) {
    return <FullScreenSpinner />;
  }

  if (auth.status === StateStatus.LOADED && authService.token) {
    if (auth?.data?.completedOnboarding === 'false' && checkIfOwner()) {
      return <Redirect to={{ pathname: '/onboard', state: { from: props.location } }} />;
    }
    return <Redirect to={{ pathname: '/management/providers', state: { from: props.location } }} />;
  }

  const handleSubmit = async data => {
    const { email, password } = data;
    const emailWithRemovedWhiteSpace = email.replace(/\s/g, '');
    const responseData = await dispatch(cognitoLogin({ email: emailWithRemovedWhiteSpace, password, persistor }));
    if (responseData === NEW_PASSWORD_REQUIRED) {
      history.push(`/verify/${email}/${password}`);
    }
  };

  return (
    <CenterMediumContent isPublicContent={false} isMobile={isMobile}>
      <Form className={isMobile ? 'mobileLogin' : 'login'} onSubmit={handleSubmit} actions={false}>
        <div className="logoBg"></div>
        <TextBox name="email" label={t('GENERAL.email')} autoComplete="username" required />
        <PasswordBox name="password" label={t('GENERAL.password')} autoComplete="current-password" required />
        <FormActions>
          <ContainedButton color="primary" type="submit" text={t('GENERAL.login')} />
          <br />
          <a
            className="forgotPasswordLink extraLinks"
            href="/"
            onClick={e => {
              e.preventDefault();
              history.push('/forgot-password');
            }}
          >
            {`${t('GENERAL.passwordForgoten')} ?`}
          </a>
          <br />
          <br />
          <a
            className="resendCodeLink extraLinks"
            href="/"
            onClick={e => {
              e.preventDefault();
              history.push('/resend-code');
            }}
          >
            {t('GENERAL.resendActivationLink')}
          </a>
        </FormActions>
        {auth?.error && (
          <Block marginLeft={6} marginRight={6}>
            <Block border={borderDefinition(theme.palette.error.main)} borderRadius={smallBorderRadius} padding={2} width="fit-content">
              <DefaultText color={theme.palette.error.main}>{auth.error.message}</DefaultText>
            </Block>
          </Block>
        )}
      </Form>
    </CenterMediumContent>
  );
};

export default withRouter(Login);
